import React, { Component } from 'react';
import { Image, Text, View } from '@react-pdf/renderer';
import { WatchlistBaseModel, WatchlistDateModel, WatchlistListsModel, WatchlistNameModel } from '../../../../domain/watchlist/WatchlistDomains';
import { WatchlistType } from '../../../../constant/Constants';
import WatchlistUtil from '../../../../util/WatchlistUtil';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistReportInformationComponent extends Component<Props> {
  render() {
    const { type } = this.props;
    return (
      <View style={{ paddingTop: '30px' }}>
        <View style={{ width: '100%', borderBottom: '1px solid #DDDDDD', gap: '2px' }}>
          <Text style={{ color: '#284564', fontSize: '14px' }}>
            {LanguageUtil.get({ id: 'pages.watchlist.reportInformationComponent.title', defaultMessage: 'Individual Information' })}
          </Text>
          <Text style={{ color: '#888888', fontSize: '10px', paddingBottom: '2px' }}>
            {LanguageUtil.get({
              id: 'pages.watchlist.reportInformationComponent.description',
              defaultMessage: 'Information found as a result of a list search according to the search criteria.',
            })}
          </Text>
        </View>
        {this.getNames()}
        {type === 'Individual' && this.getType('gender', 'Gender')}
        {type === 'Entity' && this.getType('entityType', 'Type')}
        {type == 'Individual' && this.getStatusData('identifications', 'Identifications')}
        {type == 'Entity' && this.getStatusData('identifiers', 'Identifiers')}
        {type == 'Individual' && this.getStringData('citizenships', 'Citizenships')}
        {type == 'Individual' && this.getDates('datesOfBirth', 'DatesOfBirth')}
        {type == 'Individual' && this.getDates('datesOfDeath', 'DatesOfDeath')}
        {type == 'Individual' && this.getStringData('placesOfBirth', 'PlacesOfBirth')}
        {type == 'Entity' && this.getDates('datesOfRegistration', 'DatesOfRegistration')}
        {this.getStringData('addresses', 'Addresses')}
        {type == 'Individual' && this.getStringData('positions', 'Positions')}
        {type == 'Individual' && this.getStringData('educations', 'Educations')}
        {this.getStringData('sanctions', 'Sanctions')}
        {type == 'Individual' && this.getStatusData('relationships', 'Relationships')}
        {this.getRemarks()}
        {this.getSources()}
      </View>
    );
  }

  private getNames = () => {
    const data: any[] = this.getNameGroups();
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          paddingVertical: '8px',
          columnGap: '8px',
          borderBottom: '1px solid #DDDDDD',
        }}
      >
        {this.generateHeader(LanguageUtil.get({ id: 'common.label.names', defaultMessage: 'Names' }), 'user')}
        <View style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
          {(data == undefined || data.length == 0) && this.generateNotFound()}
          {data.map((name, index) => {
            return (
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  paddingVertical: '8px',
                  borderBottom: index == data.length - 1 ? 'none' : '0.5px solid #DDDDDD',
                }}
                key={index}
              >
                <Text style={{ fontSize: '11px', color: '#4F4F4F', paddingRight: '12px', width: '100%' }}>{name.data.value}</Text>
                <Text style={{ fontSize: '11px', color: '#027A48', width: '100%' }}>
                  {name.data.nameType
                    ? name.data.nameType.charAt(0).toUpperCase() + name.data.nameType.slice(1).toLowerCase()
                    : LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' })}
                </Text>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  private getType = (property: string, displayProperty: string) => {
    const { selectedResponse } = this.props;
    const typeData = selectedResponse?.record?.records?.find((data) => (data.watchlistRecord as any)[property] !== undefined);
    const detail = (typeData?.watchlistRecord as any)?.[property];
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          paddingVertical: '8px',
          columnGap: '8px',
          borderBottom: '1px solid #DDDDDD',
        }}
      >
        {this.generateHeader(displayProperty, 'gender')}
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '80%' }}>
          <View style={{ display: 'flex', flexDirection: 'row', paddingVertical: '8px' }}>
            <Text style={{ fontSize: '11px', color: '#4F4F4F' }}>
              {detail ? detail.charAt(0).toUpperCase() + detail.slice(1).toLowerCase() : 'Not Available'}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  private getStatusData = (fieldName: string, titleName: string) => {
    const identifiersData = this.dataNormalize(fieldName);
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          paddingVertical: '8px',
          columnGap: '8px',
          borderBottom: '1px solid #DDDDDD',
        }}
      >
        {this.generateHeader(titleName, fieldName)}
        <View style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
          {(identifiersData == undefined || identifiersData.length == 0) && this.generateNotFound()}
          {identifiersData.map((data: any, index) => {
            const value: any = data.data.value || 'Not Available';
            return (
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingVertical: '8px',
                  borderBottom: index == identifiersData.length - 1 ? 'none' : '0.5px solid #DDDDDD',
                }}
                key={index}
              >
                <Text
                  style={{
                    fontSize: '11px',
                    color: fieldName == 'identifications' || fieldName == 'identifiers' ? '#8C2822' : '#4F4F4F',
                    paddingRight: '12px',
                    width: '100%',
                  }}
                >
                  {value.length > 40 ? value.substring(0, 40) + '...' : value}
                </Text>
                <Text style={{ fontSize: '11px', color: '#5925DC', width: '100%' }}>
                  {data.data.type
                    ? data.data.type.charAt(0).toUpperCase() + data.data.type.slice(1).toLowerCase()
                    : LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' })}
                </Text>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  private getStringData = (fieldName: string, titleName: string) => {
    const dataNormalize = this.dataNormalize(fieldName);
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          paddingVertical: '8px',
          columnGap: '8px',
          borderBottom: '1px solid #DDDDDD',
        }}
      >
        {this.generateHeader(titleName, fieldName)}
        <View style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
          {(dataNormalize == undefined || dataNormalize.length == 0) && this.generateNotFound()}
          {dataNormalize.map((data: any, index) => {
            let value;
            if (fieldName === 'positions' || fieldName == 'educations') {
              value = data?.data?.['name'] || LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' });
            } else if (fieldName === 'sanctions') {
              value = data?.data?.['program'] || LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' });
            } else {
              value = data?.data || LanguageUtil.get({ id: 'common.label.notAvailable', defaultMessage: 'Not Available' });
            }
            return (
              <View
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingVertical: '8px',
                  borderBottom: index == dataNormalize.length - 1 ? 'none' : '0.5px solid #DDDDDD',
                }}
              >
                <Text style={{ fontSize: '11px', color: '#4F4F4F', paddingRight: '12px', width: '100%' }}>
                  {value.length > 40 ? value.substring(0, 40) + '...' : value}
                </Text>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  private getDates = (fieldName: string, titleName: string) => {
    const dataNormalize = this.dataNormalize(fieldName);
    return (
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          paddingVertical: '8px',
          columnGap: '8px',
          borderBottom: '1px solid #DDDDDD',
        }}
      >
        {this.generateHeader(titleName, fieldName)}
        <View style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
          {(dataNormalize == undefined || dataNormalize.length == 0) && this.generateNotFound()}
          {dataNormalize.map((data: any, index) => {
            return (
              <View
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingVertical: '8px',
                  borderBottom: index == dataNormalize.length - 1 ? 'none' : '0.5px solid #DDDDDD',
                }}
              >
                <Text style={{ fontSize: '11px', color: '#4F4F4F', paddingRight: '12px', width: '100%' }}>{this.getDate(data.data)}</Text>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  private getRemarks = () => {
    const dataNormalize = this.dataNormalize('remarks');
    return (
      <View style={{ paddingTop: '30px' }}>
        <View style={{ backgroundColor: '#F2F4F7', width: '100%', borderRadius: '4px', marginTop: '8px' }}>
          <Text style={{ fontSize: '12px', color: '#4F4F4F', paddingLeft: '8px', paddingVertical: '4px', width: '100%' }}>
            {LanguageUtil.get({ id: 'common.label.remarks', defaultMessage: 'Remarks' })}
          </Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          {dataNormalize.map((data: any, index) => {
            return (
              <View
                style={{
                  width: '100%',
                  display: 'flex',
                  columnGap: '8px',
                  flexDirection: 'row',
                  borderBottom: '0.5px solid #DDDDDD !important',
                  padding: '8px',
                }}
                key={index}
              >
                <Image src={`/kyc/remarks.png`} style={{ height: '12px', width: '12px' }} />
                <View>
                  <Text style={{ fontSize: '10px', color: '#4F4F4F' }}>{data.data}</Text>
                  <Text style={{ fontSize: '10px', marginTop: '4px', color: 'black', fontWeight: 'thin' }}>{this.getList(data['watchlistId'])?.name}</Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  private getSources = () => {
    const { selectedResponse } = this.props;
    const flattenedArray: any[] =
      selectedResponse?.record?.records?.map((value) => {
        return {
          watchlistId: value.watchlistId,
          source: value.watchlistRecord.source,
        };
      }) || [];
    const dataNormalize: any[] = [].concat(...flattenedArray);
    return (
      <View style={{ paddingTop: '30px' }}>
        <View style={{ backgroundColor: '#F2F4F7', width: '100%', borderRadius: '4px', marginTop: '8px' }}>
          <Text style={{ fontSize: '12px', color: '#4F4F4F', paddingLeft: '8px', paddingVertical: '4px', width: '100%' }}>
            {LanguageUtil.get({ id: 'common.label.sources', defaultMessage: 'Sources' })}
          </Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          {dataNormalize.map((data: any, index) => {
            return (
              <View
                style={{
                  width: '100%',
                  borderBottom: '0.5px solid #DDDDDD !important',
                  padding: '8px',
                  display: 'flex',
                  columnGap: '8px',
                  flexDirection: 'row',
                }}
                key={index}
              >
                <Image src={`/kyc/sources.png`} style={{ height: '12px', width: '12px' }} />
                <View>
                  <View
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      color: '#607080',
                      fontSize: '11px',
                    }}
                  >
                    <View style={{ width: '70%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Text style={{ fontSize: '10px', color: '#4F4F4F' }}>{this.getList(data['watchlistId'])?.name}</Text>
                      <Text style={{ fontSize: '10px', color: '#458EF7' }}>{this.getList(data['watchlistId'])?.authority}</Text>
                    </View>
                    <View style={{ width: '30%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                      <Text
                        style={{
                          color: '#027A48',
                          backgroundColor: '#DBFFEA',
                          fontSize: '10px',
                          paddingHorizontal: '8px',
                          paddingVertical: '2px',
                          borderRadius: 50,
                        }}
                      >
                        {this.getList(data['watchlistId'])?.size}
                      </Text>
                      <Text style={{ fontSize: '10px', color: '#4F4F4F' }}>{this.getList(data['watchlistId'])?.country}</Text>
                    </View>
                  </View>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    );
  };

  private getList = (listId: string) => {
    const { watchlistResponse } = this.props;
    if (watchlistResponse && watchlistResponse.length > 0) {
      return watchlistResponse.find((list) => list.id == listId);
    }
  };

  private generateNotFound = () => {
    return (
      <View style={{ display: 'flex', flexDirection: 'row', paddingVertical: '8px' }}>
        <Text style={{ fontSize: '11px', color: '#4F4F4F', paddingRight: '12px', width: '100%' }}>Data not found</Text>
      </View>
    );
  };

  private getDate = (data: WatchlistDateModel) => {
    return `${data.day || ''} ${WatchlistUtil.getMonth(data.month)} ${data.year || ''}`;
  };

  private generateHeader = (title: string, icon: string) => {
    return (
      <View style={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: '8px' }}>
          <Image src={`/kyc/${icon}.png`} style={{ height: '30px', width: '30px' }} />
          <Text style={{ fontSize: '11px', color: 'black' }}>{title}</Text>
        </View>
      </View>
    );
  };

  private dataNormalize = (field: string) => {
    const { selectedResponse } = this.props;
    const flattenedArray: any[] =
      selectedResponse?.record?.records?.map((value) => {
        return (value.watchlistRecord as any)[field]?.map((data: any) => {
          return {
            data: data,
            watchlistId: value.watchlistId,
            source: value.watchlistRecord.source,
          };
        });
      }) || [];
    return [].concat(...flattenedArray);
  };

  private getNameGroups = () => {
    const namesData = this.dataNormalize('names');
    const data: any[] = [];
    const groupedData: { [key: string]: WatchlistNameModel[] } = {};
    namesData.forEach((data: any) => {
      const type = data.data.nameType;
      if (!groupedData[type]) {
        groupedData[type] = [];
      }
      groupedData[type].push(data);
    });
    for (const type in groupedData) {
      if (groupedData.hasOwnProperty(type)) {
        groupedData[type].sort((a: any, b: any) => {
          return b.data.value.length - a.data.value.length;
        });
      }
    }
    ['PRIMARY', 'ALIAS', 'SCRIPT'].forEach((type) => {
      if (groupedData[type]) {
        data.push(...groupedData[type]);
      }
    });
    return data;
  };
}

interface Props {
  selectedResponse: WatchlistBaseModel | undefined;
  watchlistResponse: WatchlistListsModel[];
  type: WatchlistType | undefined;
}

export default WatchlistReportInformationComponent;
